import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function FooterSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full" data-id="element-9" data-mp="3h8902c42uldo">
      {/* SECTION 12 - CTA FINAL */}
      <section className="py-20 sm:py-24 bg-court-night px-4 sm:px-6 lg:px-8 text-center relative overflow-hidden border-t border-white/5" data-id="element-10" data-mp="3c9fv582uw2p4">
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-11" data-mp="2okd3r8if6vhf">
          <div className="flex items-center justify-center gap-2 mb-7" data-id="element-12" data-mp="2kjb4iroi6jfg">
            <span className="text-lg" data-id="element-13" data-mp="2y9wrarh2vdim">🎾</span>
            <span className="text-cyan-400 font-heading font-bold text-sm tracking-[0.25em] uppercase" data-id="element-14" data-mp="2yaokxwr47169">
              Class Room
            </span>
          </div>

          <h2 className="text-2xl sm:text-4xl md:text-5xl font-heading font-extrabold mb-7 text-white leading-tight" data-id="element-15" data-mp="25t3tuy4qm4pb">
            El sistema de planificación N°1 para profesores de pádel.
          </h2>

          <p className="text-lg sm:text-2xl text-cyan-400 font-heading font-bold mb-10 leading-snug" data-id="element-16" data-mp="1gh845i1rhfiv">
            "Porque preparar una buena clase no debería costarte todas las
            noches de la semana."
          </p>

          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-cyan-500 hover:bg-cyan-400 text-slate-950 text-base sm:text-xl font-heading font-extrabold py-5 px-10 rounded-2xl shadow-2xl shadow-cyan-500/25 transition-all hover:scale-[1.03] flex items-center justify-center gap-3 uppercase tracking-wide mx-auto mb-9" data-id="element-17" data-mp="1q7uasmri2vpf">
            💪 → QUIERO MI PADEL 360 AHORA
          </button>

          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-slate-500 font-medium" data-id="element-18" data-mp="17i4kocyomy3u">
            <span className="flex items-center gap-2" data-id="element-19" data-mp="2ivgnqlmmbcoy">
              <ShieldCheck className="w-4 h-4 text-cyan-500" data-id="element-20" data-mp="2iuxahi7wxch9" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-21" data-mp="2muz0uv876jh8">
              <Lock className="w-4 h-4 text-cyan-500" data-id="element-22" data-mp="nr8z5pkkzlkn" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-23" data-mp="it7dcwvrt85h">
              <CreditCard className="w-4 h-4 text-cyan-500" data-id="element-24" data-mp="isnyjp1f2zvo" /> Tarjetas ·
              Transferencia
            </span>
          </div>
        </div>
      </section>

      {/* SECTION 13 - FOOTER */}
      <footer className="bg-[#020610] text-slate-500 py-12 px-4 sm:px-6 lg:px-8 text-center border-t border-white/5" data-id="element-25" data-mp="ruf0qjwr0oks">
        <div className="max-w-7xl mx-auto" data-id="element-26" data-mp="41oriig8cje7">
          <div className="text-lg font-heading font-extrabold text-white mb-6 tracking-tight" data-id="element-27" data-mp="38zu197emug">
            🎾 CLASS ROOM · PADEL 360™
          </div>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-8 font-medium text-sm" data-id="element-28" data-mp="dvp578pkuwyj">
            <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-29" data-mp="91b5wv7so5ol">
              📧 contacto@classroom.com
            </a>
            <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-30" data-mp="3cke8otdsmxne">
              📲 @classroom.padel
            </a>
            <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-31" data-mp="1s10mjuhpbepf">
              🌐 www.classroom.com
            </a>
          </div>

          <p className="text-xs border-t border-white/5 pt-8 max-w-2xl mx-auto leading-relaxed" data-id="element-32" data-mp="1wudbk5qalnip">
            © CLASS ROOM · PADEL 360™ 2024 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </footer>
    </div>;
}